import { fetchApi } from '@/shared/api/fetchApi';

export interface User {
  username: string;
  user_id: string;
}

export interface LoginCredentials {
  username: string;
  password: string;
}

interface LoginResponse {
  message: string;
}

export const authApi = {
  login: async (credentials: LoginCredentials): Promise<LoginResponse> => {
    return await fetchApi<LoginResponse>('/api/v1/public/login', {
      method: 'POST',
      body: JSON.stringify(credentials)
    });
  },

  getUser: async (): Promise<User> => {
    const user = await fetchApi<User>('/admin/api/user/');
    return user;
  },

  logout: async () => {
    return await fetchApi('/api/v1/public/logout', {
      method: 'POST'
    });
  }
};
